export const catalogCategories = Object.freeze([
 ['racing','Racing & Driving'],['sports','Sports'],['puzzle','Puzzles & Classics'],
 ['adventure','Action, Adventure & Strategy'],['casual','Casual, Creative & Simulation'],['party','Party & Multiplayer'],
]);
export const catalogDevices = Object.freeze([['','All devices'],['phone','Phone'],['tablet','Tablet'],['desktop','Desktop'],['desktop-only','Desktop only']]);
export const categoryLabel = key => catalogCategories.find(([id])=>id===key)?.[1] || key;
export function devicesFor(game){return Array.isArray(game?.metadata?.devices)?game.metadata.devices.filter(d=>['phone','tablet','desktop'].includes(d)):[];}
